import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import AddClientReducer from "./AddClientReducer";
import ClientListReducer from "./ProjectListReducer"
import TicketReducer from "../Screens/ticketSystem/ticketReducer";


const rootReducer = combineReducers({
  LoginReducer: LoginReducer,
  AddClientReducer: AddClientReducer,
  ClientListReducer: ClientListReducer,
  TicketReducer: TicketReducer,
});

export default rootReducer;
